import React, { useState } from 'react';
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa';

/** Password field with a show/hide toggle. */
const PasswordInput = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  autoComplete,
  disabled,
  required,
  minLength,
  withIcon = true,
  inputClassName,
  labelClassName = 'block text-sm font-medium text-gray-700 mb-1.5',
}) => {
  const [show, setShow] = useState(false);

  return (
    <div>
      {label && <label htmlFor={id} className={labelClassName}>{label}</label>}
      <div className="relative">
        {withIcon && (
          <FaLock className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
        )}
        <input
          id={id}
          name={name || id}
          type={show ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled}
          required={required}
          minLength={minLength}
          className={inputClassName || `w-full ${withIcon ? 'pl-10' : 'pl-4'} pr-11 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-designer-primary/30 focus:border-designer-primary transition-all duration-200`}
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? 'Hide password' : 'Show password'}
          aria-pressed={show}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-0.5 text-gray-400 hover:text-designer-primary transition-colors"
        >
          {show ? <FaEyeSlash className="w-4 h-4" /> : <FaEye className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
